import React, { useState } from "react";
import { Link } from "react-router-dom";
import { default as logo_d, default as logo_w } from "../assets/svg/logo_w.svg";
import InputField from "../components/inputField/InputField";

function InviteCode() {
  const [name, setName] = useState("");

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  return (
    <div className="logIn_page">
      <div className="log_container">
        <div className="lgoIn_left">
          <Link to="/" className="logo_area">
            <img src={logo_w} className="logo logo-white" alt="" />
            <img src={logo_d} className="logo logo-dark" alt="" />
            <h4>Casso Wealth</h4>
          </Link>
          <div>
            <p>
              "Someone is sitting in the shade today because someone planted a
              tree a long time ago. The same is true with credit; using it
              wisely can lead to future financial freedom."
            </p>
            <h4 className="name">Warren Buffett</h4>
          </div>
        </div>
        <div className="logIn_from">
          <div>
            <h1>Enter your Invite Code</h1>
          </div>
          <form action="" className="input_group mt-0">
            <InputField
              label="Invite Code"
              value={name}
              onChange={handleNameChange}
              placeholder="Invite Code"
            />
            <div className="btn_area">
              <Link to="/dashboard" className="mt-4">
                <button className="btn">Submit</button>
              </Link>
              <p className="sign_up_area">
                Go back to{" "}
                <Link to="/sign_up" className="ml-1">
                  Sign Up
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default InviteCode;
